export default "__VITE_ASSET__DXWzTqB1__"